import { alertConstants } from '../_constants';

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        type: 'alert-success',
        message: action.error,
        errors: '',
      };
    case alertConstants.ERROR:
      return {
        type: 'alert-danger',
        message: action.error.message,
        errors: action.error.errors,
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state
  }
}